import { Button } from 'admin/components/atoms/Buttons';
import LabeledSelect from 'admin/components/molecules/LabeledSelect';
import ShopSelector from 'admin/components/organisms/ShopSelector';
import React, { useEffect, useState } from 'react';
import { GroupBase } from 'react-select';
import styled from 'styled-components';
import { components } from '~/javascripts/admin/schema/docs/api/admin';

type Shop = components['schemas']['Shop'];

type ShopOption = {
  label: string;
  value: string;
  shop: Shop;
};

type SelectedShopsEditorProps = {
  coupon: {
    available_shops?: Shop[];
  };
  onChangeShops: (shops: Shop[]) => void;
  designatedMoney?: components['schemas']['PrivateMoney'];
  disabled?: boolean;
};

const SelectGroup = styled.div`
  display: flex;
  ${ShopSelector} > * {
    width: 250px;
  }
  ${Button} {
    width: 80px;
  }
`;

const SelectedShopsEditor = ({
  coupon,
  onChangeShops,
  designatedMoney,
  disabled,
  ...rest
}: SelectedShopsEditorProps) => {
  const [shop, setShop] = useState<Shop | null>(null);
  const [selectedShopOps, setSelectedShopOps] = useState<ShopOption[]>([]);

  useEffect(() => {
    if (coupon.available_shops && coupon.available_shops.length > 0) {
      const options: ShopOption[] = [];

      coupon.available_shops.forEach((s) => {
        if (s.id && s.name) {
          options.push({
            label: s.name,
            value: s.id,
            shop: s,
          });
        }
      });

      setSelectedShopOps(options);
    }
  }, [coupon]);

  useEffect(() => {
    onChangeShops(selectedShopOps.map((op) => op.shop));
  }, [selectedShopOps, onChangeShops]);

  const handleChange = (ops: readonly ShopOption[] | null) => {
    if (ops) {
      setSelectedShopOps([...ops]);
    } else {
      setSelectedShopOps([]);
    }
  };

  const handleShopSelect = (selected: Shop | null) => {
    setShop(selected);
  };

  const addSelectedShops = () => {
    if (shop && shop.id && shop.name && selectedShopOps.every((op) => op.value !== shop.id)) {
      const newOption: ShopOption = {
        label: shop.name,
        value: shop.id,
        shop,
      };

      setSelectedShopOps([...selectedShopOps, newOption]);
    }
  };

  return (
    <div {...rest}>
      <SelectGroup>
        <ShopSelector
          onChangeShop={handleShopSelect}
          designatedMoney={designatedMoney}
          disabled={disabled}
        />
        <Button variant="outline" onClick={addSelectedShops} disabled={!shop || disabled}>
          追加
        </Button>
      </SelectGroup>
      <LabeledSelect<ShopOption, true, GroupBase<ShopOption>>
        id="shopSelector"
        labelText="選択済み"
        options={[]}
        isMulti
        onChange={handleChange}
        value={selectedShopOps}
        placeholder="店舗を選んでください"
        isDisabled
      />
    </div>
  );
};

export default styled(SelectedShopsEditor)`
  ${LabeledSelect as any} {
    width: 80%;
    & > * {
      width: 100%;
    }
  }
`;
